export enum AdminPermission {
  // Workspaces
  WorkspacesRead = "workspaces:read",
  WorkspacesWrite = "workspaces:write",
  WorkspacesDelete = "workspaces:delete",

  // Workspace plans
  WorkspacePlansRead = "workspace-plans:read",
  WorkspacePlansWrite = "workspace-plans:write",

  // Workspace orders
  WorkspaceOrdersRead = "workspace-orders:read",
  WorkspaceOrdersWrite = "workspace-orders:write",

  // Unknown transactions
  UnknownTransactionsRead = "unknown-transactions:read",

  // Analytics (finance dashboard)
  AnalyticsRead = "analytics:read",

  // Costs (cost entries + cash books)
  CostsRead = "costs:read",
  CostsWrite = "costs:write",

  // Widget types
  WidgetTypesRead = "widget-types:read",
  WidgetTypesWrite = "widget-types:write",
  WidgetTypesDelete = "widget-types:delete",

  // Admin users
  AdminUsersRead = "admin-users:read",
  AdminUsersWrite = "admin-users:write",
  AdminUsersDelete = "admin-users:delete",
  AdminUsersResetPassword = "admin-users:reset-password",

  // Admin roles
  AdminRolesRead = "admin-roles:read",
  AdminRolesWrite = "admin-roles:write",
  AdminRolesDelete = "admin-roles:delete",

  // Users
  UsersRead = "users:read",
  UsersWrite = "users:write",
  UsersDelete = "users:delete",
  UsersLock = "users:lock",
  UsersSignIn = "users:sign-in",

  // Events
  EventsRead = "events:read",
  EventsWrite = "events:write",

  // Orders
  OrdersRead = "orders:read",

  // Site templates
  SiteTemplatesRead = "site-templates:read",
  SiteTemplatesWrite = "site-templates:write",
  SiteTemplatesDelete = "site-templates:delete",

  // Page templates
  PageTemplatesRead = "page-templates:read",
  PageTemplatesWrite = "page-templates:write",
  PageTemplatesDelete = "page-templates:delete",

  // Sites
  SitesRead = "sites:read",

  // Assets
  AssetsRead = "assets:read",
  AssetsWrite = "assets:write",

  // Marketplace apps
  AppsRead = "apps:read",
  AppsWrite = "apps:write",

  // Leads
  LeadsRead = "leads:read",
  LeadsWrite = "leads:write",
  LeadsDelete = "leads:delete",
}

export type AdminPermissionValue = AdminPermission;

export interface AdminRole {
  id: string;
  name: string;
  key: string;
  permissions: AdminPermission[];
  priority?: number;
  createTime: number;
  deleteTime?: number;
}
